var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.421 15.0854C19.3718 11.5338 22.3236 9.80735 22.4712 9.7087C20.7985 7.29166 18.2403 6.94637 17.3055 6.89704C15.1409 6.6504 13.0254 8.17955 11.9431 8.17955C10.8116 8.17955 9.08968 6.89704 7.2694 6.94637C4.90796 6.99569 2.6941 8.37686 1.46418 10.4979C-1.04485 14.8387 0.824624 21.202 3.23527 24.7042C4.41599 26.4307 5.8427 28.3544 7.66298 28.2558C9.43406 28.1571 10.1228 27.1213 12.2875 27.1213C14.4521 27.1213 15.0425 28.2558 16.912 28.2065C18.8306 28.1571 20.0606 26.48 21.1921 24.7535C22.5696 22.7804 23.1108 20.8567 23.16 20.758C23.16 20.758 19.4702 19.3275 19.421 15.0854Z",
    fill: "#3F3D56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8792 4.57864C16.8631 3.34546 17.5027 1.71766 17.3059 0.0405273C15.9284 0.0898547 14.1573 1.02708 13.1734 2.21093C12.2878 3.24681 11.5007 4.97326 11.6975 6.55174C13.2718 6.69972 14.8953 5.7625 15.8792 4.57864Z",
    fill: "#3F3D56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIos);
export default __webpack_public_path__ + "static/media/ios.c2aa6974db1de45d7c68a9499bbef861.svg";
export { ForwardRef as ReactComponent };